export const validateImageUrl = (url, timeoutT) => {
    return new Promise((resolve, reject) => {
        const timeout = timeoutT || 2000;
        const img = new Image();
        let timer;
        img.onerror = img.onabort = () => {
            clearTimeout(timer);
            reject('error');
        };
        img.onload = () => {
            clearTimeout(timer);
            resolve('success');
        };
        timer = setTimeout(() => {
            reject('timeout');
        }, timeout);
        img.src = url;
    });
};
